import React from 'react';
import {
    View,
    Text,
    StyleSheet,
    ScrollView,
    TouchableOpacity,
    Alert,
    StatusBar,
    Platform,
} from 'react-native';
import { Feather } from '@expo/vector-icons';
import { COLORS, APP_INFO } from '../config';
import { useAuth } from '../context/AuthContext';

export default function ProfileScreen({ navigation }) {
    const { user, logout } = useAuth();

    const handleLogout = () => {
        if (Platform.OS === 'web') {
            if (window.confirm('Yakin ingin logout dari akun ini?')) {
                logout();
            }
        } else {
            Alert.alert(
                'Keluar Akun',
                'Yakin ingin logout dari akun ini?',
                [
                    { text: 'Batal', style: 'cancel' },
                    { text: 'Ya, Logout', onPress: logout, style: 'destructive' },
                ]
            );
        }
    };

    const formatNumber = (num) => {
        return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') || '0';
    };

    const formatCurrency = (num) => {
        return 'MG ' + formatNumber(Math.floor(num || 0));
    };

    const getLevelInfo = (poin) => {
        if (poin >= 500000) return { level: 'LEGENDARY', color: '#FFD700', icon: '👑', next: null };
        if (poin >= 200000) return { level: 'DIAMOND', color: '#00D4FF', icon: '💎', next: 500000 };
        if (poin >= 100000) return { level: 'PLATINUM', color: '#A0AEC0', icon: '🏆', next: 200000 };
        if (poin >= 50000) return { level: 'GOLD', color: '#FFB300', icon: '🥇', next: 100000 };
        if (poin >= 20000) return { level: 'SILVER', color: '#94A3B8', icon: '🥈', next: 50000 };
        return { level: 'BRONZE', color: '#CD7F32', icon: '🥉', next: 20000 };
    };

    const level = getLevelInfo(user?.poin || 0);
    const progress = level.next ? ((user?.poin || 0) / level.next) * 100 : 100;

    return (
        <View style={styles.container}>
            <StatusBar barStyle="dark-content" backgroundColor={COLORS.bgDarker} />

            <ScrollView showsVerticalScrollIndicator={false}>
                {/* Enhanced Header Profile */}
                <View style={styles.header}>
                    <View style={[styles.avatar, { borderColor: level.color }]}>
                        <Text style={styles.avatarText}>{user?.nama?.charAt(0)?.toUpperCase() || '?'}</Text>
                    </View>
                    <Text style={styles.userName}>{user?.nama}</Text>

                    {/* Member ID - Enhanced Display */}
                    <View style={styles.memberIdCard}>
                        <Text style={styles.memberIdLabel}>ID MEMBER</Text>
                        <Text style={styles.memberIdValue}>{user?.kode_member}</Text>
                    </View>
                </View>

                {/* Balance Cards - Red Container with White Cards */}
                <View style={styles.balanceContainer}>
                    <View style={styles.balanceInner}>
                        <View style={styles.balanceCard}>
                            <Text style={styles.balanceLabel}>MINGURO</Text>
                            <Text style={styles.balanceValue}>{formatCurrency(user?.saldo || 0)}</Text>
                        </View>
                        <View style={styles.balanceCard}>
                            <Text style={styles.balanceLabel}>Reward Poin</Text>
                            <Text style={[styles.balanceValue, styles.poinValue]}>{formatNumber(user?.poin)}</Text>
                        </View>
                    </View>
                </View>

                {/* Compact Info Section */}
                <View style={styles.infoSection}>
                    <Text style={styles.sectionTitle}>Informasi Akun</Text>

                    <View style={styles.infoCard}>
                        <View style={styles.infoItem}>
                            <View style={styles.infoContent}>
                                <Text style={styles.infoLabel}>Nomor Telepon</Text>
                                <Text style={styles.infoValue}>{user?.telepon}</Text>
                            </View>
                        </View>

                        <View style={styles.infoDivider} />

                        <View style={styles.infoItem}>
                            <View style={styles.infoContent}>
                                <Text style={styles.infoLabel}>Email</Text>
                                <Text style={styles.infoValue}>{user?.email || '-'}</Text>
                            </View>
                        </View>

                        <View style={styles.infoDivider} />

                        <View style={styles.infoItem}>
                            <View style={styles.infoContent}>
                                <Text style={styles.infoLabel}>Total Transaksi</Text>
                                <Text style={styles.infoValue}>{user?.total_main || 0}x</Text>
                            </View>
                        </View>
                    </View>
                </View>

                {/* Compact Actions */}
                <View style={styles.actionsSection}>
                    <Text style={styles.sectionTitle}>Lainnya</Text>
                    <TouchableOpacity
                        style={styles.menuItem}
                        activeOpacity={0.7}
                        onPress={() => navigation.navigate('KartuMember')}
                    >
                        <Text style={styles.menuLabel}>Kartu Member</Text>
                        <Feather name="chevron-right" size={18} color={COLORS.textMuted} />
                    </TouchableOpacity>

                    <TouchableOpacity
                        style={styles.menuItem}
                        activeOpacity={0.7}
                        onPress={() => navigation.navigate('Hadiah')}
                    >
                        <Text style={styles.menuLabel}>Hadiah Saya</Text>
                        <Feather name="chevron-right" size={18} color={COLORS.textMuted} />
                    </TouchableOpacity>

                    <TouchableOpacity
                        style={styles.menuItem}
                        activeOpacity={0.7}
                        onPress={() => navigation.navigate('Bantuan')}
                    >
                        <Text style={styles.menuLabel}>Bantuan</Text>
                        <Feather name="chevron-right" size={18} color={COLORS.textMuted} />
                    </TouchableOpacity>
                </View>

                {/* Enhanced Logout */}
                <TouchableOpacity
                    style={styles.logoutButton}
                    activeOpacity={0.8}
                    onPress={handleLogout}
                >
                    <Feather name="log-out" size={18} color={COLORS.danger} />
                    <Text style={styles.logoutText}>Keluar</Text>
                </TouchableOpacity>

                <Text style={styles.version}>{APP_INFO.fullName} v{APP_INFO.version}</Text>


                <View style={{ height: 100 }} />
            </ScrollView>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: COLORS.bgDark,
    },
    header: {
        alignItems: 'center',
        paddingTop: 40,
        paddingBottom: 16,
        backgroundColor: COLORS.bgDarker,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
        shadowColor: COLORS.primary,
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.1,
        shadowRadius: 12,
        elevation: 6,
    },
    avatar: {
        width: 70,
        height: 70,
        borderRadius: 35,
        backgroundColor: COLORS.primary + '12',
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 3,
        marginBottom: 10,
        shadowColor: COLORS.primary,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.15,
        shadowRadius: 8,
        elevation: 4,
    },
    avatarText: {
        fontSize: 28,
        fontWeight: '800',
        color: COLORS.primary,
    },
    userName: {
        fontSize: 20,
        fontWeight: '800',
        color: COLORS.textPrimary,
        marginBottom: 8,
        letterSpacing: -0.3,
    },
    levelBadge: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderRadius: 20,
        marginBottom: 14,
        gap: 6,
    },
    levelIcon: {
        fontSize: 16,
    },
    levelText: {
        fontWeight: '700',
        fontSize: 12,
        letterSpacing: 1,
    },
    memberIdCard: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: COLORS.primary + '12',
        paddingHorizontal: 12,
        paddingVertical: 6,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: COLORS.primary + '25',
        gap: 6,
    },
    memberIdLabel: {
        fontSize: 10,
        color: COLORS.primary,
        fontWeight: '600',
    },
    memberIdValue: {
        fontSize: 12,
        color: COLORS.primary,
        fontWeight: '800',
    },
    levelBadge: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderRadius: 20,
        gap: 6,
    },
    levelIcon: {
        fontSize: 16,
    },
    levelText: {
        fontWeight: '700',
        fontSize: 12,
        letterSpacing: 1,
    },
    // Balance Container - Red Background
    balanceContainer: {
        marginHorizontal: 16,
        marginTop: 12,
        backgroundColor: COLORS.primary,
        borderRadius: 16,
        padding: 16,
        shadowColor: COLORS.primary,
        shadowOffset: { width: 0, height: 6 },
        shadowOpacity: 0.25,
        shadowRadius: 12,
        elevation: 6,
    },
    balanceInner: {
        flexDirection: 'row',
        gap: 10,
    },
    balanceCard: {
        flex: 1,
        backgroundColor: '#FFFFFF',
        borderRadius: 12,
        padding: 14,
        alignItems: 'flex-start',
    },
    balanceLabel: {
        fontSize: 12,
        color: '#666666',
        fontWeight: '500',
        marginBottom: 6,
    },
    balanceValue: {
        fontSize: 14,
        fontWeight: '800',
        color: '#1A1A1A',
    },
    poinValue: {
        marginLeft: 8,
    },
    progressSection: {
        paddingHorizontal: 20,
        marginBottom: 20,
    },
    progressHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 8,
    },
    progressTitle: {
        fontSize: 14,
        fontWeight: '600',
        color: COLORS.textPrimary,
    },
    progressPercent: {
        fontSize: 14,
        fontWeight: '600',
        color: COLORS.primary,
    },
    progressBar: {
        height: 10,
        backgroundColor: COLORS.border,
        borderRadius: 5,
        overflow: 'hidden',
        marginBottom: 8,
    },
    progressFill: {
        height: '100%',
        borderRadius: 5,
    },
    progressNote: {
        fontSize: 11,
        color: COLORS.textMuted,
    },
    infoSection: {
        paddingHorizontal: 16,
        marginTop: 20,
        marginBottom: 16,
    },
    sectionTitle: {
        fontSize: 15,
        fontWeight: '700',
        color: COLORS.textPrimary,
        marginBottom: 10,
    },
    infoCard: {
        backgroundColor: COLORS.bgCard,
        borderRadius: 12,
        overflow: 'hidden',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.04,
        shadowRadius: 6,
        elevation: 2,
        borderWidth: 1,
        borderColor: COLORS.borderLight,
    },
    infoItem: {
        padding: 12,
    },
    infoDivider: {
        height: 1,
        backgroundColor: COLORS.borderLight,
        marginHorizontal: 18,
    },
    infoIconContainer: {
        width: 40,
        height: 40,
        borderRadius: 12,
        backgroundColor: COLORS.primary + '10',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 14,
    },
    infoContent: {
        flex: 1,
    },
    infoLabel: {
        fontSize: 11,
        color: COLORS.textMuted,
        marginBottom: 2,
    },
    infoValue: {
        fontSize: 15,
        color: COLORS.textPrimary,
        fontWeight: '500',
    },
    actionsSection: {
        paddingHorizontal: 16,
        marginBottom: 16,
        gap: 6,
    },
    menuItem: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: COLORS.bgCard,
        borderRadius: 10,
        padding: 12,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.04,
        shadowRadius: 4,
        elevation: 1,
        borderWidth: 1,
        borderColor: COLORS.borderLight,
    },
    menuIconContainer: {
        width: 40,
        height: 40,
        borderRadius: 12,
        backgroundColor: COLORS.primary + '10',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 14,
    },
    menuLabel: {
        flex: 1,
        fontSize: 15,
        color: COLORS.textPrimary,
        fontWeight: '600',
    },
    logoutButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: COLORS.danger + '10',
        marginHorizontal: 20,
        marginTop: 8,
        padding: 16,
        borderRadius: 16,
        borderWidth: 1.5,
        borderColor: COLORS.danger + '25',
        gap: 10,
    },
    logoutIcon: {
        fontSize: 18,
    },
    logoutText: {
        color: COLORS.danger,
        fontWeight: '600',
        fontSize: 15,
    },
    version: {
        textAlign: 'center',
        color: COLORS.textMuted,
        fontSize: 12,
        marginTop: 20,
    },
    tagline: {
        textAlign: 'center',
        color: COLORS.primary,
        fontSize: 11,
        marginTop: 4,
        fontWeight: '500',
    },
});
